import { SCREEN_NAME, IMPRESSION_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionSelfDeliveryInstruction = (
    cartId: string,
    restId: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SELF_DELIVERY_INSTRUCTIONS,
        context: JSON.stringify({ cartId, restId }),
    });
};
